import { uploadFileStatusSelector } from "../redux/selector";
import { toast } from "react-toastify";
import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  uploadFileStart,
  uploadFileSuccess,
  uploadFileFailed,
} from "../redux/uploadFile";

import { get } from "lodash";

import { ReduxStateType } from "redux-store/types";
import { changeFormErrors } from "redux-store/static/redux/validation";
import { GLOBAL_VALIDATION } from "helper/enum/globalValidation";
import { postFileApi } from "core/http/service/timeKeeping";
import { updateFormReq } from "../redux/formReqLeave";

function* replaceFilesWithUrls(data: any) {
  const { callback, updateForm } = data.payload;
  let obj = data.payload.obj;

  const promises = [];
  function* recursiveReplace(obj, currentPath = "") {
    for (const key in obj) {
      if (key.includes("_files")) {
        const fieldNameFiles = `${currentPath}${key}`.replace("_files", "");
        const valueFiles = get(obj, key.replace("_files", "")) ?? [];
        for (let i = 0; i < obj[key].length; i++) {
          const promise = call(function* () {
            const fieldName = `${fieldNameFiles}.${i + valueFiles.length}`;

            // const currentfieldName = `${currentPath}${key}`;
            // const fieldNameFileContent = currentfieldName.replace(
            //   "_files",
            //   "_file_contents"
            // );
            // const valueCurrentfieldName = (
            //   get(obj, currentfieldName) ?? []
            // ).filter((item, index) => index !== i);

            // const valuefieldNameFileContent = (
            //   get(obj, fieldNameFileContent) ?? []
            // ).filter((item, index) => index !== i);

            try {
              const url = yield call(postFileApi, obj[key][i]);
              yield put({
                type: updateForm ? updateForm?.type : updateFormReq.type,
                payload: {
                  [fieldName]: url,
                  // [currentfieldName]: valueCurrentfieldName,
                  // [fieldNameFileContent]: valuefieldNameFileContent,
                },
              });
            } catch (error) {
              const fileImageName = error?.response?.data?.dataInput;
              toast.error(
                `File ${fileImageName?.split("fileName: ")[1]! || ""} tải lên không thành công, vui lòng thử lại`
              );
              yield put({
                type: uploadFileFailed.type,
                payload: error,
              });

              // yield put({
              //   type: formReqLeaveUpdate.type,
              //   payload: {
              //     [fieldName]: get(
              //       obj,
              //       `${key.replace("_files", "_file_contents")}.${i}`
              //     ),
              //   },
              // });

              yield put({
                type: changeFormErrors.type,
                payload: {
                  key: GLOBAL_VALIDATION.ADD_LEAVE_REQ_VALIDATION,
                  payload: (prevState) => ({
                    isScrollToFirstError: true,
                    formErrors: {
                      ...prevState.formErrors,
                      [fieldNameFiles]: "Tải file lên không thành công",
                    },
                  }),
                },
              });
            }
          });
          promises.push(promise);
        }
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        yield* recursiveReplace(obj[key], `${currentPath}${key}.`);
      }
    }
  }

  yield* recursiveReplace(obj);

  try {
    yield all(promises);
    const uploadFileStatusSelectorData = yield select(uploadFileStatusSelector);

    if (callback && uploadFileStatusSelectorData !== ReduxStateType.ERROR) {
      yield put({
        type: uploadFileSuccess.type,
      });
      callback();
    }
  } catch (error) {}
}

function* watchUploadFile() {
  yield takeLatest(uploadFileStart.type, replaceFilesWithUrls);
}

export default function* uploadFileSaga() {
  yield all([watchUploadFile()]);
}
